import { PhoneIcon } from '@heroicons/react/outline'
import { StarIcon } from '@heroicons/react/outline'
import BookACallButton from './Buttons/Specials/BookACallButton'
import HomepageBookCallLeadModal from './Modals/HomepageBookCallLeadModal'

const SWITCH_TO_US_MODAL_PROPS = {
    meetingTitle: 'Switch to Us Book a Call',
    formName: 'Switch To Us Strategy Call',
}

export default function TransformRealEstateJourney({
    coupon = 'SWITCH15',
    discount = '15',
}) {
    return (
        <div
            className="max-w-full w-[1200px] px-6 m-auto my-16 space-y-8"
            id="claimSwitch15">
            <h3 className="font-bold text-center text-3xl md:text-[55px] md:leading-[65px] xl:leading-tight space-x-1">
                <span>Ready to Transform Your</span>
                <br />
                <span>Real Estate Journey</span>?
                <br />
                <span>Use Code:</span>
                <span className="olm-gradient-text underline">{coupon}</span>
            </h3>
            <div className="flex md:flex-row md:flex-nowrap md:space-x-3 flex-col md:space-y-0 space-y-3 text-white md:text-left text-center">
                <div className="md:w-1/2 md:p-14 px-4 py-8 rounded-[20px] olm-black-gradient-darker-45 space-y-4">
                    <PhoneIcon
                        className="h-10 w-10 text-[#F28230] md:m-0 m-auto"
                        aria-hidden="true"
                    />
                    <h3 className="font-bold text-[28px] leading-[35px] md:text-[35px] md:leading-[40px]">
                        Get connected with your dedicated Marketing Coaches now!
                    </h3>
                    {/* <a href="/contact-us" className="inline-block">
                        <button className="max-w-[22rem] w-full font-semibold olm-gradient px-8 py-5 rounded shadow md:text-[20px] md:leading-6 text-[18px] leading-5">
                            Contact our CSR Team now
                        </button>
                    </a> */}
                    <div className="md:w-9/12 w-full inline-block">
                        <BookACallButton
                            Modal={HomepageBookCallLeadModal}
                            modalProps={SWITCH_TO_US_MODAL_PROPS}>
                            Book a Call
                        </BookACallButton>
                    </div>
                </div>
                <div className="md:w-1/2 md:p-14 px-4 py-8 rounded-[20px] bg-olm-gradient-diagonal-75 space-y-4">
                    <StarIcon
                        className="h-10 w-10 md:m-0 m-auto"
                        aria-hidden="true"
                    />
                    <h3 className="font-bold text-[28px] leading-[35px] md:text-[35px] md:leading-[40px]">
                        Start Your Campaign Today
                    </h3>
                    <p className="md:text-xl font-medium text-lg">
                        To begin a campaign tailored to your specific needs and
                        to take your real estate investment to the next level,
                    </p>
                    <a href="/products" className="inline-block">
                        <button className="max-w-[21rem] w-full font-semibold bg-black px-10 py-5 rounded shadow md:text-[20px] md:leading-6 text-[18px] leading-5">
                            Claim {discount}% OFF Now
                        </button>
                    </a>
                </div>
            </div>
        </div>
    )
}
